import { Divider, Stack, Typography } from "@mui/material";
import { isTruthy } from "helpers/methods";
import { useContext } from "react";
import { CampaignContext } from "../Context";

interface CustomProps {
  for: "subject" | "from";
  string: string;
}

const InboxPreview = (props: CustomProps) => {
  const { submitCampaign } = useContext(CampaignContext);

  const getSenderName = () => {
    return props.for === "from"
      ? props.string?.trim()
        ? props.string
        : "Sender"
      : submitCampaign.campaign.displayName;
  };

  return (
    <Stack
      spacing={1}
      divider={<Divider />}
      sx={{
        borderLeft: "1px solid #CECECE",
        borderRight: "1px solid #CECECE",
      }}
    >
      <Stack sx={{ opacity: 0.3 }} p={1.5}>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="subtitle1">Lisa Anderson</Typography>
          <Typography variant="subtitle1">17:05</Typography>
        </Stack>
        <Typography variant="body2" color="text.secondary">
          Your Eco-Friendly Packaging Awaits
        </Typography>
      </Stack>
      <Stack p={1.5}>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="subtitle1" title={getSenderName()} noWrap>
            {getSenderName()}
          </Typography>
          <Typography variant="subtitle1">10:10</Typography>
        </Stack>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflowWrap: "break-word",
          }}
        >
          {props.for === "subject" && isTruthy(props.string)
            ? props.string
            : isTruthy(submitCampaign.campaign.subject)
            ? submitCampaign.campaign.subject
            : "Message subject..."}
        </Typography>
      </Stack>
      <Stack sx={{ opacity: 0.3 }} p={1.5}>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="subtitle1">Sophia Mitchell</Typography>
          <Typography variant="subtitle1">08:10</Typography>
        </Stack>
        <Typography variant="body2" color="text.secondary">
          Exclusive Offer Just for You 🛍️
        </Typography>
      </Stack>
    </Stack>
  );
};

export default InboxPreview;
